export const theme = {
	colors: {
		text: "#2A2A2A",
		white: "#FFFFFF",
		light: "#F5F5F5",
		mat: "#00000029",
		prymaryBtnColor: "#00B3FA",
		secondaryBtnColor: "#F6E224",
		link: "#008BF6",
	},
	whiteShadowRight:
		"transparent linear-gradient(270deg, #ffffff 0%, #ffffff00 100%) 0% 0% no-repeat padding-box",
	whiteShadowLeft:
		"transparent linear-gradient(90deg, #FFFFFF 0%, #FFFFFF00 100%) 0% 0% no-repeat padding-box;",
	shadow: "0px 3px 6px #00000029",
	shadowBtn: "rgba(0, 0, 0, 0.6) 5px 7px 18px;",
	radii: {
		r10: "10px",
		r26: "26px",
		r30: "30px",
		r50: "50%",
	},
	breakpoints: [
		"320px",
		"420px",
		"520px",
		"620px",
		"720px",
		"820px",
		"920px",
		"1020px",
		"1080px",
	],
	fonts: {
		body: '"Poppins", sans-serif',
	},
	fontWeights: {
		regular: 400,
		medium: 500,
		SemiBold: 600,
		bold: 700,
		extraBold: 800,
		black: 900,
	},
	fontSizes: {
		fs9: "9px",
		fs10: "10px",
		fs11: "11px",
		fs12: "12px",
		fs13: "13px",
		fs14: "14px",
		fs15: "15px",
		fs16: "16px",
		fs17: "17px",
		fs18: "18px",
		fs19: "19px",
		fs20: "20px",
		fs21: "21px",
		fs22: "22px",
		fs23: "23px",
		fs24: "24px",
		fs25: "25px",
		fs26: "26px",
		fs27: "27px",
		fs28: "28px",
		fs30: "30px",
		fs31: "31px",
		fs36: "36px",
		fs38: "38px",
		fs41: "41px",
		fs48: "48px",
		fs60: "60px",
		fs64: "64px",
		fs84: "84px",
	},

	lineHeights: {
		lh10: "1",
		lh11: "1.1",
		lh12: "1.2",
		lh13: "1.3",
		lh14: "1.4",
		lh15: "1.5",
		lh16: "1.6",
		lh17: "1.7",
		lh18: "1.8",
		lh19: "1.9",
		lh20: "2",
		lh21: "2.1",
		lh22: "2.2",
		lh23: "2.3",
	},
};
